import { Entity, makeClone } from 'gossamer-unified';
import { User } from './User';
import { Person } from './Person';
import { InstitutionMember } from './InstitutionMember';

export interface InstitutionMemberViewRow {
  user_id: string;
  email: string;
  created_at: string;
  person_id: number;
  first_name: string;
  last_name: string;
  phone_number: string;
  photo: string | null;
  date_of_birth: string | null;
  occupation: string | null;
  address_id: number | null;
  institution_member_id: number;
  institution_id: number;
  is_admin: boolean;
  is_verified: boolean;
  membership_created_at: string;
}

const clone = makeClone();

// access conditions
const IS_ME = "user_id = '{userId}'";
const IS_MEMBER_OF_MY_INSTITUTION = '(institution_id = {adminInstitutionId})';

export const InstitutionMemberView: Entity<InstitutionMemberViewRow> = {
  id: 'InstitutionMemberView',
  title: 'Institution Member View',
  service: 'main',
  rowLabel: (row: InstitutionMemberViewRow) => [row.first_name, row.last_name].join(' '),
  primaryKeyFields: ['institution_member_id'],
  source: {
    tableName: 'public.institution_member_view',
  },
  security: [
    {
      role: 'admin',
      action: 'read',
      access: 'conditional',
      condition: [IS_ME, IS_MEMBER_OF_MY_INSTITUTION].join(' OR '),
    },
    { role: 'admin', action: 'all', access: 'conditional', condition: IS_MEMBER_OF_MY_INSTITUTION },
    { role: 'staff', action: 'all', access: 'all' },
  ],
  defaultSort: [['email', 'ASC']],
  defaultFilters: [{ fieldId: 'email', operator: 'ct', value: '' }],
  listRowLink: '/admin/institution-member/display/{key}',
  fields: {
    user_id: clone(User.fields.id, { seq: 5, listColumn: false }),
    first_name: clone(Person.fields.first_name, { seq: 10, listColumn: true }),
    last_name: clone(Person.fields.last_name, { seq: 15, listColumn: true }),
    email: clone(User.fields.email, { seq: 20, listColumn: true }),
    phone_number: clone(Person.fields.phone_number, { seq: 25, listColumn: false }),
    photo: clone(Person.fields.photo, { seq: 30, listColumn: false }),
    date_of_birth: clone(Person.fields.date_of_birth, { seq: 35, listColumn: false }),
    occupation: clone(Person.fields.occupation, { seq: 40, listColumn: false }),
    created_at: clone(User.fields.created_at, { seq: 45, listColumn: false }),
    person_id: clone(User.fields.person_id, { seq: 50, listColumn: false, filterable: false }),
    address_id: clone(Person.fields.address_id, { seq: 55, listColumn: false }),
    institution_member_id: clone(InstitutionMember.fields.id, { seq: 60, listColumn: false }),
    institution_id: clone(InstitutionMember.fields.institution_id, { seq: 65, listColumn: false }),
    is_admin: clone(InstitutionMember.fields.is_admin, { seq: 70, listColumn: false }),
    is_verified: clone(InstitutionMember.fields.is_verified, { seq: 75, listColumn: false }),
    membership_created_at: clone(InstitutionMember.fields.created_at, { seq: 80, listColumn: false }),
  },
};
